import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Features from "./pages/Features";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Support from "./pages/Support";

import PrivacyPolicy from "./policies/PrivacyPolicy";
import Terms from "./policies/Terms";
import RefundPolicy from "./policies/RefundPolicy";
import CookiePolicy from "./policies/CookiePolicy";
import DataDeletion from "./policies/DataDeletion";
import CommunityGuidelines from "./policies/CommunityGuidelines";

import Header from "./components/Header";
import Footer from "./components/Footer";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />

      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/features" element={<Features />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/support" element={<Support />} />

        {/* Policy Pages */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/delete-data" element={<DataDeletion />} />
        <Route path="/community" element={<CommunityGuidelines />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;

